package com.cybersoftsolution.cybersoftsolutionweb.navigation


import com.cybersoftsolution.cybersoftsolutionweb.api.buildParams
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.AUTH_LOGIN_ROUTE
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import kotlinx.browser.window


fun PageContext.redirectTo(apiRoute:String,params : MutableMap<String, Any?>){
//     window.location.href = this.route.origin + "/api" + apiRoute


//     window.location.href = this.route.origin + "/api" + apiRoute + "?CLIENT_ROOT_URI=${window.location.protocol}//${window.location.host}"
     window.location.href = this.route.origin + "/api" + apiRoute + params.buildParams()  // + "?CLIENT_ROOT_URI=${this.route.origin}"
    }